import { DISALLOWED_QUERIES } from 'constants/tripla'
import { v4 as uuid } from 'uuid'

export function isSSORedirect() {
  if (window.location.pathname === '/sso/custom/callback') return true

  const url = window.location.toString()
  return (
    (url.includes('isLINERedirect=true') || url.includes('isLINERedirect%3Dtrue')) &&
    !url.includes('line_redirect')
  )
}

export const containsEmail = (raw) => {
  return /((?!@)|(?!%40))(@|%40)[\w\d]+\.[\w\d]+/i.test(raw)
}

export const cleanUpUrl = (raw) => {
  let ret = raw

  DISALLOWED_QUERIES.forEach((name) => {
    // filter unescaped case
    ret = ret.replace(new RegExp(`(\\?|&)${name}=[^&]+(&|$)`, 'ig'), '$1')
    // filter escaped case
    ret = ret.replace(new RegExp(`(%3f|%26)${name}%3d.+?(%26|$)`, 'ig'), '$1')
  })

  // destroy all emails
  ret = ret.replace(/((?!@)|(?!%40))(@|%40)[\w\d]+\.[\w\d]+/, '')

  return ret
}

export const promiseWait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export const randomHash = (length = 12) => {
  let ret = ''
  const samples = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < length; i++) {
    ret += samples.charAt(Math.floor(Math.random() * samples.length))
  }
  return ret
}

export const getSessionHash = () => {
  try {
    let sessionHash = sessionStorage.getItem('BW_SESSION_HASH')
    if (!sessionHash) {
      sessionHash = randomHash(6)
      sessionStorage.setItem('BW_SESSION_HASH', sessionHash)
    }
    return sessionHash
  } catch (err) {
    return randomHash() || uuid()
  }
}

export const getLocalStorageHash = () => {
  try {
    let localStorageHash = localStorage.getItem('BW_LOCAL_HASH')
    if (!localStorageHash) {
      localStorageHash = randomHash(6)
      localStorage.setItem('BW_LOCAL_HASH', localStorageHash)
    }
    return localStorageHash
  } catch (err) {
    return randomHash() || uuid()
  }
}
